import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  sessionId: z.string().min(1),
  currentFile: z.string().nullable().optional(),
  cursorLine: z.number().nullable().optional(),
  cursorColumn: z.number().nullable().optional(),
  status: z.enum(['online', 'meeting', 'away', 'offline']).optional(),
  selection: z
    .object({
      startLine: z.number().nullable(),
      startColumn: z.number().nullable(),
      endLine: z.number().nullable(),
      endColumn: z.number().nullable(),
    })
    .optional(),
});

export type InputType = z.infer<typeof schema>;

export type OutputType = {
  success: boolean;
};

export const updatePresence = async (body: InputType, init?: RequestInit): Promise<OutputType> => {
  const validatedInput = schema.parse(body);
  const result = await fetch(`/_api/presence/update`, {
    method: 'POST',
    credentials: 'include',
    body: superjson.stringify(validatedInput),
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
